/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nData from './i18nData'

Vue.use(VueI18n)

function getLang() {
  const locale = localStorage.getItem('lang')
  if (locale !== null && locale !== undefined) {
    return locale;
  }
  if (navigator.languages !== undefined)
    return navigator.languages[0];
  else
    return navigator.language;
}

export default new VueI18n({
  locale: getLang(), // set default locale,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: i18nData,
})
